<script setup lang="ts">
import {
  ToastProvider as ToastProviderComponent,
  type ToastProviderProps,
} from "reka-ui";

type Props = ToastProviderProps;

const props = withDefaults(defineProps<Props>(), {
  label: "Notification",
  duration: 5000,
  swipeDirection: "right",
});
</script>

<template>
  <ToastProviderComponent v-bind="props">
    <slot />
  </ToastProviderComponent>
</template>
